import DbService from 'resources/db.service';
import config from 'config';
import moment from 'moment';
import schema from './company.schema';

const service = new DbService('companies', { schema });

const createCompany = async () => {
  const response = await service.create({
    env: config.env,
    trial_expires_on: moment().add(14, 'days').toDate(),
  });

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

export const updateCompany = async (updateData) => {
  let response = await service.updateOne({ id: updateData.id }, updateData);

  return response.data;
};

const getCompanyById = async (companyId) => service.findById(companyId);

export default Object.assign(service, {
  createCompany,
  updateCompany,
  getCompanyById,
});
